import React, { useState } from "react";
import { EpisodeTag } from "./EpisodeTag.js";

import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";

export const EpisodeTagCarousel = (props) => {
    let {episodes} = props;
    let [focusItem, setFocusItem] = useState(null);

    function handleMouseEnter(movieId) {
      setFocusItem(movieId);
    }

    function handleMouseLeave() {
      setFocusItem(null);
    }

      //let visibleSlides, slideSize;

      let visibleSlides = 3.5;
      let slideSize = {
        width: "24vw",
        height: "19.4vw"
      }

    return (
      <CarouselProvider
        className="ep_tag carousel_container"
        naturalSlideWidth={slideSize.width}
        naturalSlideHeight={slideSize.height}
        totalSlides={episodes.length}
        isIntrinsicHeight={true}
        touchEnabled={true}
        visibleSlides={visibleSlides}
      >
        <Slider>
          {episodes.map((item, index) => (
            <Slide index={index} key={index}>
              <EpisodeTag
                listControl={{
                  episodeData: item,
                  episodeId: item.id,
                  focusItem: focusItem,
                  setFocusItem: setFocusItem,
                  handleMouseEnter: handleMouseEnter,
                  handleMouseLeave: handleMouseLeave
                }}
              />
            </Slide>
          ))}
        </Slider>
        <div className="ep_tag carousel_control">
          <ButtonBack className="carousel_btn">
            <svg className="svg-icon" viewBox="0 0 20 20">
              <path d="M8.388,10.049l4.76-4.873c0.303-0.31,0.297-0.804-0.012-1.105c-0.309-0.304-0.803-0.293-1.105,0.012L6.726,9.516c-0.303,0.31-0.296,0.805,0.012,1.105l5.433,5.307c0.152,0.148,0.35,0.223,0.547,0.223c0.203,0,0.406-0.08,0.559-0.236c0.303-0.309,0.295-0.803-0.012-1.104L8.388,10.049z"></path>
            </svg>
          </ButtonBack>
          <ButtonNext className="carousel_btn">
            <svg className="svg-icon" viewBox="0 0 20 20">
              <path d="M11.611,10.049l-4.76-4.873c-0.303-0.31-0.297-0.804,0.012-1.105c0.309-0.304,0.803-0.293,1.105,0.012l5.306,5.433c0.304,0.31,0.296,0.805-0.012,1.105L7.83,15.928c-0.152,0.148-0.35,0.223-0.547,0.223c-0.203,0-0.406-0.08-0.559-0.236c-0.303-0.309-0.295-0.803,0.012-1.104L11.611,10.049z"></path>
            </svg>
          </ButtonNext>
        </div>
      </CarouselProvider>
    );
}